import httpRequest from '@/utils/request'

// 分页查询
export function getList(data: any): Promise<any> {
    return httpRequest({
        url: '/ext/workorderExt/page',
        method: 'post',
        data
    })
}

// 工单统计列表数量
export function pageCount(data: any): Promise<any> {
    return httpRequest({
        url: '/ext/workorderExt/pageCount',
        method: 'post',
        data
    })
}

// 根据ID查询
export function queryById(id: any): Promise<any> {
    return httpRequest({
        url: `ext/workorderExt/${id}`,
        method: 'get'
    })
}

// 分类组合接口2
export function checkAllList(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/categoryUnionExt/checkAllList',
        method: 'post',
        data
    })
}

// 根据用户查询 - 设备列表
export function getListByUser (): Promise<any> {
    return httpRequest({
        url: 'ext/userDeviceExt/getListByUser',
        method: 'post'
    })
}

// 查询当前用户所有主组织下的工序
export function warehouseList(data: any): Promise<any> {
  return httpRequest({
      url: '/ext/warehouseExt/page',
      method: 'post',
      data
  })
}

// 完工入库详情
export function finishedDetail (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderExt/finishedDetail',
        method: 'get',
        params
    })
}

// 根据条件查询工装
export function getListByCondition(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/appliancesExt/getListByCondition',
        method: 'post',
        data
    })
}

// 新建投料
export function createMaterial(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/createMaterial',
        method: 'post',
        data
    })
}

// 新建投料 - 标准版
export function createMaterialStandard(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/createMaterialStandard',
        method: 'post',
        data
    })
}

// 获取扫描条码内容
export function getBarcodeContent(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/barcodeParamExt/getBarcodeContent',
        method: 'get',
        params
    })
}

// 查询全部工单生产过程记录
export function getOrocessRecord(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/all',
        method: 'post',
        data
    })
}

// 工装器具根据ID查询
export function toolingQueryById(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/appliancesExt/getListByCondition',
        method: 'post',
        data
    })
}

// 新建产出
export function createProduce(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/createProduce',
        method: 'post',
        data
    })
}

// 删除产出/投料单条记录
export function deleteCT (id: any): Promise<any> {
    return httpRequest({
        url: `/ext/workorderRecordExt/delete/${id}`,
        method: 'get'
    })
}

// 根据ID修改产出-投料数量
export function updateById (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/updateById',
        method: 'post',
        data
    })
}

// 根据篮筐分组统计报废和不良数量
export function listGroupByAppliance (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderCheckExt/listGroupByAppliance',
        method: 'post',
        data
    })
}

// 确认报工
export function comfirmDone (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/comfirmDone',
        method: 'post',
        data
    })
}

// 确认报工 - 标准版
export function comfirmDoneStandard (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/comfirmDoneStandard',
        method: 'post',
        data
    })
}

// 根据条件查询所有的检点属性
export function getJdList (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/checkAttrExt/getListByCondition',
        method: 'post',
        data
    })
}

// 新建点检
export function createDJ (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderCheckAttrExt/create',
        method: 'post',
        data
    })
}

// 点检分页查询
export function pageDJ (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderCheckAttrExt/page',
        method: 'post',
        data
    })
}

// 完工入库提交
export function finished (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderExt/finished',
        method: 'get',
        params
    })
}

// 完工入库详情记录
export function saveFinishRecord (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderExt/saveFinishRecord',
        method: 'post',
        data
    })
}

// 完工入库详情记录 --- 待办进入
export function getFinishRecord (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderExt/getFinishRecord',
        method: 'get',
        params
    })
}

// 根据ID查询设备详情
export function getSbInfo (id: any): Promise<any> {
    return httpRequest({
        url: `ext/deviceExt/${id}`,
        method: 'get'
    })
}

// 据入库货位筛选入库单 - H5
export function finishedInBill (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/finishedInBill',
        method: 'get',
        params
    })
}

// 用户绑定设备
export function bindingDevice (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/userDeviceExt/create',
        method: 'post',
        data
    })
}

// 工装分页查询
export function toolingList (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/appliancesExt/page',
        method: 'post',
        data
    })
}

// 更换篮筐
export function chageApplicance (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/appliancesExt/chageApplicance',
        method: 'post',
        data
    })
}

// 申请单，返工返修申请不良原因
export function checkFGFXList (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/categoryUnionExt/checkFGFXList',
        method: 'get',
        params
    })
}

// 查询公司级全部
export function allData (data: any): Promise<any> {
    return httpRequest({
        url: 'business/salesorder/allData',
        method: 'post',
        data
    })
}

// 根据ID查询工序
export function getGXItem (id: any): Promise<any> {
    return httpRequest({
        url: `ext/proceduresExt/${id}`,
        method: 'get'
    })
}

// 新建返工返修申请单
export function createSingle (data: any): Promise<any> {
    return httpRequest({
        url: 'business/backorder/create',
        method: 'post',
        data
    })
}

// 查询当前用户所有主组织下的工序
export function productesGroup (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/proceduresExt/productesGroup',
        method: 'post',
        data
    })
}

// 申请单分页查询
export function sqdCage (data: any): Promise<any> {
    return httpRequest({
        url: 'business/backorder/page',
        method: 'post',
        data
    })
}

// 申请单根据id查询详细
export function getsqdInfo (id: any): Promise<any> {
    return httpRequest({
        url: `business/backorder/${id}`,
        method: 'get'
    })
}

// 申请单---根据工厂id查询工序
export function productesGroups (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/proceduresExt/productesGroup',
        method: 'post',
        data
    })
}

// 完工入库详情 - NEW
export function finishedDetailNew (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderExt/finishedDetailNew',
        method: 'get',
        params
    })
}

// 根据工单查询工艺卡
export function getListByWorkOrderId (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/routeCardExt/getListByWorkOrderId',
        method: 'post',
        data
    })
}

// 终检工装扫描
export function getEndCheckAP (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/getEndCheckAP',
        method: 'get',
        params
    })
}

// 根据ID查询设备
export function deletedj (id: any): Promise<any> {
    return httpRequest({
        url: `ext/workorderCheckAttrExt/delete/${id}`,
        method: 'get'
    })
}

// 库存量查询 - H5
export function pageForH5 (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wStockExt/pageForH5',
        method: 'post',
        data
    })
}

// 货位分页查询
export function pageHW (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/warehouseLocationExt/page',
        method: 'post',
        data
    })
}

// 根据仓库查询仓库下货位信息
export function getListByWarehouseId (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/warehouseLocationExt/getListByWarehouseId',
        method: 'get',
        params
    })
}

// 手工转库 - H5
export function scanTransfer (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wTransferExt/scanTransfer',
        method: 'post',
        data
    })
}

// 查询全部 - 标准
export function allForStandard (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/allForStandard',
        method: 'post',
        data
    })
}

// 生成投料记录 - standard
export function dealWorkorderRecordStandard (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/dealWorkorderRecordStandard',
        method: 'post',
        data
    })
}

// 查询产出记录列表
export function getWorkorderRecordListStandard (params: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderRecordExt/getWorkorderRecordListStandard',
        method: 'get',
        params
    })
}

/***
 * 根据ID查询工装信息
 * @param id
 */
export function getGzInfo (id: any): Promise<any> {
    return httpRequest({
        url: `ext/appliancesExt/${id}`,
        method: 'get'
    })
}

/**
 * 确认备料详情
 * @param params id: 转库id
 * @returns
 */
 export function wTransferConfirm(params: any): Promise<any> {
  return httpRequest({
      url:  '/ext/wTransferExt/wTransferConfirm',
      method: 'get',
      params
  })
}

/**
* 接受备料
* @param params id: id
* @returns
*/
export function acceptWTransfer(params: any): Promise<any> {
  return httpRequest({
      url:  '/ext/wTransferExt/acceptWTransfer',
      method: 'get',
      params
  })
}

// 新增出库
export function createForStandard (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/wOutboundExt/createForStandard',
        method: 'post',
        data
    })
}

// 库存调整、采购入库入库单创建
export function wOutBoundForStockUp (data: any): Promise<any> {
    return httpRequest({
        url: '/ext/wOutboundExt/wOutBoundForStockUp',
        method: 'post',
        data
    })
}